import React from 'react';
import './IdPassort.css';
import { SalesContext } from '../../Context/SalesContext';
import { checkInputValidity, createArray, validateDate } from './../../Utility/utility';
import { tagOnPersonalDetailsInteraction } from '../../Tagging/SalesTagging';

import {
  getCountryList,
  getCountryValuesFromJsonService
} from '../../Services/Services';
import { IdPassportIcon } from '../Common';
import { FormFieldLabel } from 'src/StyledComponents';
import VettingInput from '../Common/VettingInput/VettingInput';
import VettingDropDown from '../Common/VettingDropDown/VettingDropDown';

class IdPassport extends React.Component {
  static contextType = SalesContext;

  state = {
    formComponents: {
      idNumber: {
        idType: {
          name: 'ID type',
          type: 'dropDown',
          value: 'SA ID number',
          options: ['SA ID number', 'Passport number'],
          width: 43,
          validations: {
            required: true,
            invalidMessage: 'Please select ID type',
          },
          config: {
            type: 'select',
            required: true,
            placeholder: 'Select status',
            tabIndex: '1'
          },
          isValid: true,
          isTouched: true
        },
        idNumber: {
          name: 'SA ID number',
          type: 'input',
          value: this.context?.employmentDetails?.idNumber,
          width: 55,
          validations: {
            required: true,
            type: 'idNumber',
            invalidMessage: 'Please enter a valid SA ID number',
          },
          config: {
            type: 'text',
            required: true,
            placeholder: 'Enter your ID number',
            tabIndex: '2'
          },
          isValid: false,
          isTouched: false,
          note: 'We need this to verify your information'
        }
      },
      passportNumber: {
        idType: {
          name: 'ID type',
          type: 'dropDown',
          value: 'Passport number',
          options: ['SA ID number', 'Passport number'],
          width: 43,
          validations: {
            required: true,
            invalidMessage: 'Please select ID type',
          },
          config: {
            type: 'select',
            required: true,
            placeholder: 'Select status',
            tabIndex: '1'
          },
          isValid: true,
          isTouched: true
        },
        passportNumber: {
          name: 'Passport number',
          type: 'input',
          value: this.context?.employmentDetails?.passportNumber,
          width: 55,
          validations: {
            required: true,
            invalidMessage: 'Please enter a valid passport number',
          },
          config: {
            type: 'text',
            required: true,
            placeholder: 'Enter your passport number',
            tabIndex: '2',
            maxLength:50
          },
          isValid: false,
          isTouched: false,
          note: 'We need this to verify your information'
        },
        countryOfIssue: {
          name: 'Country of issue',
          type: 'dropDown',
          value: this.context?.employmentDetails?.countryOfIssue,
          options: [],
          width: 43,
          validations: {
            required: true,
            invalidMessage: 'Please select a country',
          },
          config: {
            type: 'select',
            required: true,
            placeholder: 'Select a country',
            tabIndex: '1'
          },
          isValid: false,
          isTouched: false
        },
        dateOfExpiry: {
          name: 'Date of expiry',
          type: 'input',
          value: this.context?.employmentDetails?.dateOfExpiry,
          width: 55,
          validations: {
            required: true,
            invalidMessage: 'Please enter a valid date of expiry',
          },
          config: {
            type: 'date',
            required: true,
            placeholder: 'DD-MM-YYYY',
            tabIndex: '2',
            max: '2525-01-01',
          },
          isValid: false,
          isTouched: false
        },
      }
    },
    isFormValid: false,
    selectedIdTab: this.context.employmentDetails.selectedIdTab,
    formSubmitAttempt: 0,
    hasError: false,
    passportForm: [],
    idForm: [],
  }

  tabSwitchClick = option => {
    let formCopy = { ...this.state.formComponents[option]}
    for (let key in formCopy) {
      let formData = formCopy[key];
      if (key !== 'idType') {
        if (formData.value) {
          this.ComponentChangeHandler(formData.value, key, option)
        }
      }
    }

    this.setState({ selectedIdTab: option, isFormValid: this.checkFormValidity(this.state.formComponents, option) });
    this.context.setEmploymentDetails({ key: 'selectedIdTab', value: option });
    this.props.validIdPassportDetails(this.checkFormValidity(this.state.formComponents, option));
  }

  checkFormValidity = (form, selectedIdTab = this.state.selectedIdTab) => {
    if (selectedIdTab === 'idNumber'){
      return (form['idNumber']['idNumber'].isValid);
    }else{
      return (
        form['passportNumber']['passportNumber'].isValid &&
        form['passportNumber']['countryOfIssue'].isValid &&
        form['passportNumber']['dateOfExpiry'].isValid 
      )
    }
  }

  ComponentChangeHandler = (value, inputIdentifier, selectedIdTab) => {
    if (value.length === 1) {
      tagOnPersonalDetailsInteraction();
    }
    const formCompsCopy = { ...this.state.formComponents };
    const changedComponent = { ...formCompsCopy[selectedIdTab][inputIdentifier]};
    if (inputIdentifier === 'passportNumber' || inputIdentifier === 'idNumber') {
      changedComponent.value = value.trim();
    }
    else {
      changedComponent.value = value;
    }
    
    changedComponent.isValid = checkInputValidity(changedComponent.value, changedComponent.validations);
    changedComponent.isTouched = true;

    if (inputIdentifier === 'dateOfExpiry') {
      let currentDate = new Date();
      let date = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());
      let passportDate = new Date(value);
      if (validateDate(passportDate.getDay(), passportDate.getMonth(), passportDate.getFullYear()) && passportDate > date) {
        changedComponent.isValid = true
      }
      else {
        changedComponent.isValid = false
      }
    }
    
    this.context.setEmploymentDetails({ key: inputIdentifier, value: changedComponent.value });
    formCompsCopy[selectedIdTab][inputIdentifier] = changedComponent;
    this.setState({ formComponents: formCompsCopy, isFormValid: this.checkFormValidity(formCompsCopy) });
    this.props.validIdPassportDetails(this.checkFormValidity(formCompsCopy));
    this.setState({passportForm: createArray(this.state.formComponents.passportNumber), idForm: createArray(this.state.formComponents.idNumber)})
  }
  
  componentDidMount() {
    let formCopy = { ...this.state.formComponents[this.state.selectedIdTab]}
    for (let key in formCopy) {
      let formData = formCopy[key];
      if (key !== 'idType') {
        if (formData.value) {
          this.ComponentChangeHandler(formData.value, key, this.state.selectedIdTab)
        }
      }
    }

    const formCompsCopy = { ...this.state.formComponents };    
    
    const isFormValid = this.checkFormValidity(formCompsCopy, this.context.employmentDetails.selectedIdTab);

    if (isFormValid) {
      this.props.validIdPassportDetails(true);
    } else {
      this.props.validIdPassportDetails(false);
    }

    getCountryList().then(res => {
      // set to formData Obj
      const changedComponent = { ...formCompsCopy['passportNumber']['countryOfIssue'] }
      let options = res?.result?.COUNTRY.map(item => item.description);
      changedComponent.options = options;
      formCompsCopy['passportNumber']['countryOfIssue'] = changedComponent;
      this.setState({ formComponents: formCompsCopy, isFormValid: isFormValid, selectedIdTab: this.context.employmentDetails.selectedIdTab });
      this.setState({passportForm: createArray(this.state.formComponents.passportNumber), idForm: createArray(this.state.formComponents.idNumber)})
    })
    .catch(_error => {
      getCountryValuesFromJsonService().then(res => {
        const changedComponent = { ...formCompsCopy['passportNumber']['countryOfIssue'] };
        let options = res?.result?.COUNTRY.map(item => item.description);
        changedComponent.options = options;
        formCompsCopy['passportNumber']['countryOfIssue'] = changedComponent;
        this.setState({ formComponents: formCompsCopy, isFormValid: isFormValid, selectedIdTab: this.context.employmentDetails.selectedIdTab });
        this.setState({passportForm: createArray(this.state.formComponents.passportNumber), idForm: createArray(this.state.formComponents.idNumber)})
      })
      .catch(_error =>{
        console.error('[AnotherAddress][getProvinceList][Fail]');
      })
    })

    this.setState({passportForm: createArray(this.state.formComponents.passportNumber), idForm: createArray(this.state.formComponents.idNumber)})
  }

  updateTab = (key, option) => {
    if (key === 'idType')
      if (option === 'Passport number') {
        this.tabSwitchClick('passportNumber')
      }
      else {
        this.tabSwitchClick('idNumber')
      }
    else {
      this.ComponentChangeHandler(option, 'countryOfIssue', this.state.selectedIdTab )
    }
  }

  render() {
    return (
      <div className="id-passport-details-wrapper">
        <div className="id-passport-heading">
          <div className="id-passport-heading-icon">
            <IdPassportIcon />
          </div>
          ID/Passport number
        </div>
        <hr className='id-passport-hr'/>

        {
          this.state.selectedIdTab === 'idNumber'
          ? <div className='id-section'>
            {
              this.state.idForm.map((item, index) => {
                return (
                  <div className={`input-field-wrapper-${item?.config?.width}`} key={index}>
                    <FormFieldLabel>
                      {item.config.name}
                    </FormFieldLabel>
                    {
                      item.config.type === 'input' &&
                        <VettingInput
                          {...item.config}
                          inputIdentifier={item.key}
                          updateValue={(value) => this.ComponentChangeHandler(value, item.key, this.state.selectedIdTab)}
                        />
                    }
                    {
                      item.config.type === 'dropDown' &&
                        <VettingDropDown
                          {...item.config}
                          selectedValue={item.config?.value}
                          placeholder={item.config?.config?.placeholder}
                          options={item.config?.options}
                          inputIdentifier={item?.key}
                          updateSelectedOption={(option) => this.updateTab(item.key, option)}
                        />
                    }
                  </div>
                )
              })
            }
            </div>
          : <div className='passport-section'>
            {
              this.state.passportForm.map((item, index) => {
                return (
                  <div className={`input-field-wrapper-${item?.config?.width}`} key={index}>
                    <FormFieldLabel>
                      {item.config.name}
                    </FormFieldLabel>
                    {
                      item.config.type === 'input' &&
                        <VettingInput
                          {...item.config}
                          inputIdentifier={item.key}
                          updateValue={(value) => this.ComponentChangeHandler(value, item.key, this.state.selectedIdTab)}
                        />
                    }
                    {
                      item.config.type === 'dropDown' &&
                        <VettingDropDown
                          {...item.config}
                          selectedValue={item.config?.value}
                          placeholder={item.config?.config?.placeholder}
                          options={item.config?.options}
                          inputIdentifier={item?.key}
                          updateSelectedOption={(option) => this.updateTab(item.key, option)}
                        />
                    }
                  </div>
                )
              })
            }

            </div>
        }
      </div>
    )
  }
}


export default IdPassport;